import { render, staticRenderFns } from "./WithdrawalApplication.vue?vue&type=template&id=b5a3046c"
import script from "./WithdrawalApplication.vue?vue&type=script&lang=js"
export * from "./WithdrawalApplication.vue?vue&type=script&lang=js"
import style0 from "./WithdrawalApplication.vue?vue&type=style&index=0&id=b5a3046c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports